import React from 'react';
import { profile } from '../data/content';

export default function Contact() {
  return (
    <section className="contact" id="contact">
      <p className="section-title">Contact</p>
      <h2>Get in touch</h2>
      <div className="contact__info">
        <a href={`mailto:${profile.email}`} className="contact__item">{profile.email}</a>
        <a href={`tel:${profile.phone.replace(/\s/g, '')}`} className="contact__item">{profile.phone}</a>
      </div>
      <div className="contact__links">
        <a href={profile.linkedin} target="_blank" rel="noopener noreferrer" className="contact__link" aria-label="LinkedIn">
          LinkedIn
        </a>
        <a href={profile.github} target="_blank" rel="noopener noreferrer" className="contact__link" aria-label="GitHub">
          GitHub
        </a>
      </div>
    </section>
  );
}
